import React, { useState, useEffect } from "react";
import { IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

const SlidingGrid = ({ children, width = 350 }) => {
    const [isVisible, setIsVisible] = useState(true); // Default: panel is visible
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1366);

    const toggleVisibility = () => {
        setIsVisible(!isVisible); // Toggle panel visibility
    };

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth < 1366);
        };

        window.addEventListener("resize", handleResize);

        // Cleanup listener on unmount
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);


    return (
        <div
            style={{
                position: "relative",
                width: "100vw", // Ensure the container spans the viewport
                height: "100vh",
                overflow: "hidden", // Prevent scrolling artifacts
            }}
        >
            {/* Sliding Grid */}
            <div
                style={{
                    position: "fixed", // Use fixed to align the grid relative to the viewport
                    top: 0,
                    right: isVisible ? 0 : `-${width}px`, // Slide off to the right
                    width: `${width}px`,
                    height: "100%",
                    padding: 0,
                    display: "flex",
                    flexDirection: "column",
                    backgroundColor: "#f4f4f4",
                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
                    transition: "right 0.3s ease", // Smooth transition
                    zIndex: 10,
                }}
            >
                {children}
            </div>

            {/* Floating Toggle Button when content is to small to hide nav */}
            {/* {isSmallScreen && 
                <IconButton
                    onClick={toggleVisibility}
                    style={{
                        position: "fixed", // Use fixed to keep the button in the viewport
                        top: 10,
                        right: isVisible ? `${width + 10}px` : `10px`, // Dynamically adjust based on panel state
                        zIndex: 20,
                        backgroundColor: "#ffffff",
                        boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
                    }}
                >
                    {isVisible ? <ChevronRight /> : <ChevronLeft />}
                </IconButton>
            } */}
        </div>
    );
};

export default SlidingGrid;